import { RouterProvider } from 'react-router';

import { TooltipProvider, DEFAULT_TOOLTIP_DELAY_MS } from '#/modules/commonComponents/tooltip';
import router from '#/modules/infra/router';

const App = () => {
  return (
    <TooltipProvider delayDuration={DEFAULT_TOOLTIP_DELAY_MS}>
      <RouterProvider router={router} />
    </TooltipProvider>
  );
};

export default App;
